import React from 'react';

import './index.scss';

import CrossIcon from 'components/atoms/Icon/CrossIcon';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import PcInputTitle from 'components/molecules/PcInputTitle';

const PcModal = ({
  modalIsOpen,
  errorDispMessages,
  content,
  button,
  onClickCloseButton,
  selectedDate,
  comment,
  radioChild
}) => {
  if (modalIsOpen) {
    return (
      <div className="PM-overlay" onClick={onClickCloseButton}>
        <div className="PM-content" onClick={(e) => e.stopPropagation()}>
          <div className="PM-wrapper">
            <div className="PM-information">
              <PcInputTitle title={content.title} subTitle={content.subTitle} list={content.list} label={content.label} questionMark={content.questionMark} popUpTitle={content.popUpTitle} popUpDetail={content.popUpDetail} type={content.type} selectedDate={selectedDate} errorDispMessages={errorDispMessages} comment={comment} radioChild={radioChild} />
            </div>
            <div className="PM-next-button">
              <ClickOnlyButton label={button.label} onClick={button.onClick} valid={button.valid} />
            </div>
            <button className="PM-close-button" type="button" onClick={onClickCloseButton}><CrossIcon /></button>
          </div>
        </div>
      </div>
    );
  }
  return null;


};

export default PcModal;